import { render, staticRenderFns } from "./core.vue?vue&type=template&id=42cc61dc&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc61dc",
  null
  
)

export default component.exports